import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { websitePageUrl } from '../../../app/locale/websitePath';
import { authV2Messages } from './authV2Messages';

// formatMessage returns an array when a message has tags, so each link has a key.
const linkRenderer =
  (key: string, href: string) =>
  (chunks: React.ReactNode): React.ReactNode => (
    <a key={key} href={href} target="_blank" rel="noreferrer">
      {chunks}
    </a>
  );

/**
 * The Terms and Privacy line under the form (design: onboarding g1, g8). The links open the pages
 * of music24.com in the language of this page (QA 2026-10-28, lit-20).
 */
const AuthLegalComponent: React.FC = () => {
  const intl = useIntl();
  const { locale } = intl;
  const links = useMemo(
    () => ({
      terms: linkRenderer('terms', websitePageUrl('terms-of-service', locale)),
      privacy: linkRenderer('privacy', websitePageUrl('privacy-policy', locale)),
    }),
    [locale]
  );
  return <p className="au-legal">{intl.formatMessage(authV2Messages.legal, links)}</p>;
};

export const AuthLegal = TypedMemo(AuthLegalComponent);
